import * as React from 'react';
import { useCallback, useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';


const RequestCodeFragment = (): JSX.Element => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const auth = useAuth();
    const navigate = useNavigate();

    const onUsernameChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setUsername(event.target.value);
    }, []);

    const onPasswordChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    }, []);

    const onSubmit = useCallback(async (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault();

        let token = undefined;
        try {
            token = auth ? ( await auth.login( username, password)) : null;
        } catch (e) {
            console.error(e);
            setError(e + '');
        }
        if (token) {
            navigate( '/')
        }
        else {
            // TODO handle email/phone error
        }
    }, [auth, navigate, password, username]);

    return (
        <form onSubmit={onSubmit}>
            <Stack spacing={1} sx={{}}>
                <Typography variant='h3' sx={{ mb: 2 }}>Login</Typography>
                <TextField name='username' placeholder='usernsme' value={username} error={error !== ''} helperText={error} onChange={onUsernameChange} autoFocus/>
                <TextField name='password' type='password' value={password} onChange={onPasswordChange} />
                <Button variant='contained' type='submit'>Login</Button>
            </Stack>
        </form>
    )
}

export default RequestCodeFragment;
